const DEFAULT_LOCALE_CODE = 'ru';

export const createInternalLink = (localeCode: string, pathname: string) => {
  return `${localeCode === DEFAULT_LOCALE_CODE ? '' : `/${localeCode}`}${pathname}`;
};
